// extracted by mini-css-extract-plugin
export default {"overflow":"styles_overflow__A2vnh"};